module.exports = __webpack_public_path__ + "img/127.556ed75c.jpg";